import { IEntriesKnisotItem } from '../../../../../../../modules/API/Knisot/models/entrie'

export const createObjectsArray = (
  object: IEntriesKnisotItem,
  multiplier: number,
  isCopyWithWeight: boolean,
  allCopies = false,
): IEntriesKnisotItem[] => {
  const result: IEntriesKnisotItem[] = []

  for (let i = 0; i < multiplier; i++) {
    const isCopy = allCopies || i !== 0
    const newObject = { ...object }

    // Внешний номер уникален — остаётся только на оригинале.
    if (isCopy) {
      newObject.ExternalPallet = 0
    }
    if (!isCopyWithWeight && isCopy) {
      result.push({ ...newObject, Gross: 0 })
      continue
    }
    result.push(newObject)
  }
  return result
}
